import { Icon } from '@innovationnorway/cl-react';
import { createColumnHelper } from '@tanstack/react-table';
import React from 'react';
import { OneWayInFeedbackDto } from 'src/api/v2';
const columnHelper = createColumnHelper<OneWayInFeedbackDto>();
export const otherReviewTableColumns = [
  columnHelper.accessor((row) => row.wasCorrectlyReferred, {
    id: 'referredCorrectly',
    size: 100,
    maxSize: 100,
    enableSorting: false,
    cell: (info) => (
      <Icon
        prefix="fasr"
        iconName={info.getValue() ? 'check-circle' : 'times'}
        size="l"
        color={info.getValue() ? '#2fcc72' : '#ed0000'}
        className="margin-right--1"
      />
    ),
  }),
  columnHelper.accessor((row) => row.clusterName, {
    id: 'actorName',
    cell: (info) => <span>{info.getValue()}</span>,
  }),
  columnHelper.accessor((row) => row.comment, {
    id: 'comment',
    cell: (info) => <span>{info.getValue()}</span>,
  }),
];
